module.exports = __webpack_public_path__ + "img/bri.60d2c0a5.png";